import {http} from '@/http'

export default {
  list(data, params) {
    return http.post('/api/v1/rides/list', data, {params})
  },
  create(data) {
    return http.post('/api/v1/rides', data)
  },
  getById(id) {
    return http.get(`/api/v1/rides/${id}`)
  },
  update(id, data) {
    return http.put(`/api/v1/rides/${id}`, data)
  },
  updateStatus(id, status) {
    return http.put(`/api/v1/rides/${id}/status`, {estado: status})
  },
  assign(id, data) {
    return http.put(`/api/v1/rides/${id}/assign`, data)
  },
  // Completa o cambia el conductor designado de un transportista (DEF-ADM-018).
  assignDriver(id, data) {
    return http.put(`/api/v1/rides/${id}/assign-driver`, data)
  },
  updatePayment(id, data) {
    return http.put(`/api/v1/rides/${id}/payment`, data)
  },
  delete(id) {
    return http.delete(`/api/v1/rides/${id}`)
  },
  stats(params) {
    return http.get('/api/v1/rides/stats', {params})
  },
  getBookingSources() {
    return http.get('/api/v1/booking-sources')
  },
  calculatePrice(data) {
    return http.post('/api/v1/rides/calculate-price', data)
  },
  exportExcel(data) {
    return http.post('/api/v1/rides/export', data, { responseType: 'blob' })
  }
}
